import { FC } from "react";
import { Alert as AntAlert, AlertProps as AntAlertProps } from "antd";
import { clsx } from "clsx";
import classes from "./Alert.module.less";
import { SvgIcon } from "../../../common/components/SvgIcon";

const AlertIconNameMap = new Map<AlertType, string>([
    ["info", "alert"],
    ["success", "success"],
    ["warning", "alert"],
    ["error", "error"],
]);

export type AlertType = "info" | "success" | "warning" | "error";
export interface AlertProps extends AntAlertProps {}

export const Alert: FC<AlertProps> = ({ className, type = "info", showIcon, ...restProps }) => {
    const iconName = AlertIconNameMap.get(type);
    return (
        <AntAlert
            closeIcon={<SvgIcon name="close" size={12} className={classes.close} />}
            icon={
                showIcon &&
                iconName && <SvgIcon name={iconName} size={18} className={classes.icon} />
            }
            {...restProps}
            showIcon={showIcon}
            type={type}
            className={clsx(classes.alert, classes[`alert--${type}`], className)}
        />
    );
};

Alert.displayName = "Alert";
